// delivery.ts

import { consola } from 'consola'

const logger = consola.withTag('delivery-const')

export interface DeliveryRule {
  min_order_amount: number
  max_order_amount: number | null
  delivery_cost: number
}

/**
 * Возвращает стоимость доставки (delivery_cost) по delivery_rules из API.
 * Если сумма корзины попадает в диапазон правила — возвращается соответствующая стоимость.
 * Если правило не найдено — возвращает 0.
 */
export function getDeliveryCostByRules(
  sum: number,
  deliveryRules: DeliveryRule[] | null | undefined,
): number {
  // Защита от null, undefined или не массива
  if (!deliveryRules || !Array.isArray(deliveryRules) || deliveryRules.length === 0) {
    logger.warn('⚠️ [getDeliveryCostByRules] deliveryRules is not a valid array:', deliveryRules)
    return 0
  }

  logger.log('📦 [getDeliveryCostByRules] Calculating delivery cost:', {
    sum,
    rulesCount: deliveryRules.length,
    rules: deliveryRules,
  })

  for (const rule of deliveryRules) {
    const min = rule.min_order_amount ?? 0
    const max = rule.max_order_amount ?? Infinity

    logger.log('🔍 [getDeliveryCostByRules] Checking rule:', {
      min,
      max,
      deliveryCost: rule.delivery_cost,
      sumInRange: sum >= min && sum < max,
    })

    if (sum >= min && sum < max) {
      logger.log('✅ [getDeliveryCostByRules] Rule matched! Delivery cost:', rule.delivery_cost)
      return rule.delivery_cost
    }
  }

  // Если ни одно правило не подошло, возвращаем 0
  logger.warn('⚠️ [getDeliveryCostByRules] No matching rule found, returning 0')
  return 0
}
